var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog"},[_c('div',{staticClass:"dialog-box"},[_c('div',{staticClass:"dialog-error"},[_vm._v(_vm._s(_vm.error))]),_c('div',{staticClass:"dialog-bnts"},[_c('div',{staticClass:"dialog-bnt-r dialog-btn",on:{"click":function($event){return _vm.cancelDialog()}}},[_vm._v("确认")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }